"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames3 = _interopRequireDefault(require("classnames"));

var _createPictureUrlFromColor = _interopRequireDefault(require("@sift/skipper/helpers/createPictureUrlFromColor"));

var _get2 = _interopRequireDefault(require("lodash/get"));

var _Avatar = _interopRequireDefault(require("@sift/skipper/components/Avatar"));

var _Menu = _interopRequireDefault(require("@material-ui/core/Menu"));

var _IconButton = _interopRequireDefault(require("@material-ui/core/IconButton"));

var _MoreVert = _interopRequireDefault(require("@material-ui/icons/MoreVert"));

var _colorManipulator = require("@material-ui/core/styles/colorManipulator");

var _AppLink = _interopRequireDefault(require("@sift/skipper/components/appBar/AppLink"));

var _MenuItems = _interopRequireDefault(require("@sift/skipper/components/appBar/MenuItems"));

var _withStyles = _interopRequireDefault(require("@material-ui/core/styles/withStyles"));

var _defineStyles = require("@sift/skipper/styles/defineStyles");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var styles = (0, _defineStyles.defineStyles)(function (theme) {
  return {
    root: {
      textDecoration: 'none',
      position: 'relative',
      marginLeft: theme.spacing(0.75),
      display: 'flex',
      alignItems: 'center',
      cursor: 'pointer',
      minWidth: '150px'
    },
    link: {
      display: 'flex',
      flex: '1 1 auto',
      alignItems: 'center',
      borderRadius: 999,
      color: theme.palette.text.primary,
      padding: theme.spacing(0.5, 0.75),
      '&:hover': {
        backgroundColor: "".concat(theme.palette.primary.dark, " !important"),
        '& #person-menu-display-name': {
          color: theme.palette.primary.contrastText
        }
      }
    },
    linkActive: {
      backgroundColor: "".concat(theme.palette.primary.dark, " !important")
    },
    linkPrimary: {
      color: theme.palette.originalPrimary.contrastText,
      '&:hover': {
        backgroundColor: (0, _colorManipulator.fade)(theme.palette.action.active, theme.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      }
    },
    linkSecondary: {
      color: theme.palette.originalSecondary.contrastText,
      '&:hover': {
        backgroundColor: (0, _colorManipulator.fade)(theme.palette.action.active, theme.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      }
    },
    icon: {
      color: theme.palette.primary.contrastText,
      flex: '0 0 auto',
      marginLeft: theme.spacing(1),
      '&:hover': {
        backgroundColor: theme.palette.primary.dark
      }
    },
    iconPrimary: {
      color: theme.palette.originalPrimary.contrastText
    },
    iconSecondary: {
      color: theme.palette.originalSecondary.contrastText
    },
    avatarContainer: {},
    avatarNew: {
      marginRight: theme.spacing(1)
    },
    name: {
      minWidth: '100px',
      fontWeight: 600,
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      maxWidth: '180px',
      padding: 2
    },
    menuPaper: {
      minWidth: 200,
      top: '65px !important'
    },
    menuItemLink: {
      color: theme.palette.text.primary
    }
  };
});
/**
 * A Person/Profile dropdown to easily give user access to a list of
 * available routes (applications, settings, admin, etc.).
 *
 * Overrides for styling are provided via `color` and `classes`.
 */

var PersonMenu = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(PersonMenu, _React$PureComponent);

  var _super = _createSuper(PersonMenu);

  function PersonMenu() {
    var _this;

    _classCallCheck(this, PersonMenu);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      openPopover: false,
      anchorEl: null
    });

    _defineProperty(_assertThisInitialized(_this), "handleOpen", function (event) {
      _this.setState({
        openPopover: true,
        anchorEl: event.currentTarget
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleClose", function () {
      _this.setState({
        openPopover: false
      });
    });

    return _this;
  }

  _createClass(PersonMenu, [{
    key: "render",
    value: function render() {
      var _classnames, _classnames2;

      var _this$props = this.props,
          pictureUrl = _this$props.pictureUrl,
          person = _this$props.person,
          navBarRoutes = _this$props.navBarRoutes,
          accountRoutes = _this$props.accountRoutes,
          additionalRoutes = _this$props.additionalRoutes,
          msTeamsRoutes = _this$props.msTeamsRoutes,
          color = _this$props.color,
          className = _this$props.className,
          classes = _this$props.classes,
          theme = _this$props.theme,
          onProfileClick = _this$props.onProfileClick;
      var _this$props$person = this.props.person,
          displayName = _this$props$person.displayName,
          accountOnly = _this$props$person.accountOnly;
      var primaryDark = (0, _get2["default"])(theme, ['palette', 'primary', 'dark'], '#212121');
      var defaultPictureUrl = (0, _createPictureUrlFromColor["default"])(primaryDark);

      var avatar = this.props.avatar || /*#__PURE__*/_react["default"].createElement(_Avatar["default"], {
        className: classes.avatarNew,
        pictureUrl: pictureUrl || defaultPictureUrl,
        alt: displayName
      });

      var personClasses = (0, _classnames3["default"])(classes.link, (_classnames = {}, _defineProperty(_classnames, classes.linkPrimary, color === 'primary'), _defineProperty(_classnames, classes.linkSecondary, color === 'secondary'), _classnames));
      var iconClasses = (0, _classnames3["default"])(classes.icon, (_classnames2 = {}, _defineProperty(_classnames2, classes.iconPrimary, color === 'primary'), _defineProperty(_classnames2, classes.iconSecondary, color === 'secondary'), _classnames2));
      var rootClasses = (0, _classnames3["default"])(classes.root, className);
      var hasProfile = person.products.directory && !accountOnly;

      var menu = /*#__PURE__*/_react["default"].createElement(_Menu["default"], {
        classes: {
          paper: classes.menuPaper
        },
        open: this.state.openPopover,
        anchorEl: this.state.anchorEl,
        onClose: this.handleClose
      }, /*#__PURE__*/_react["default"].createElement(_MenuItems["default"], {
        navBarRoutes: navBarRoutes,
        accountRoutes: accountRoutes,
        additionalRoutes: additionalRoutes,
        msTeamsRoutes: msTeamsRoutes,
        person: person,
        classes: {
          menuItemLink: classes.menuItemLink
        }
      }));

      if (!hasProfile) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: rootClasses
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: personClasses,
          onClick: this.handleOpen
        }, avatar, /*#__PURE__*/_react["default"].createElement("div", {
          className: classes.name
        }, displayName), /*#__PURE__*/_react["default"].createElement(_MoreVert["default"], {
          className: iconClasses
        })), menu);
      }

      return /*#__PURE__*/_react["default"].createElement("div", {
        className: rootClasses
      }, /*#__PURE__*/_react["default"].createElement(_AppLink["default"], {
        className: personClasses,
        to: "/profile/".concat(person.id),
        onClick: onProfileClick,
        activeClassName: classes.linkActive
      }, avatar, /*#__PURE__*/_react["default"].createElement("div", {
        className: classes.name,
        id: "person-menu-display-name"
      }, displayName)), /*#__PURE__*/_react["default"].createElement(_IconButton["default"], {
        onClick: this.handleOpen,
        className: iconClasses
      }, /*#__PURE__*/_react["default"].createElement(_MoreVert["default"], null)), menu);
    }
  }]);

  return PersonMenu;
}(_react["default"].PureComponent);

var _default = (0, _withStyles["default"])(styles, {
  name: 'SkpAppBarPersonMenu',
  withTheme: true
})(PersonMenu);

exports["default"] = _default;